'use client';
import React, { useCallback, useState, useTransition } from 'react';
import { useTranslations } from 'next-intl';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Conditional, useBreakpoint } from '@cat-ecom/pcc-components';
import { CatSideMenu, CatSideMenuItem } from 'components/blocks-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { SidePanelProps } from '../../types';
import { CustomerAccountLoading } from '../../loading';
import styles from '../../customer-account.module.scss';

export const SidePanel = ({
  searchParam,
  mobile,
  children,
  sideMenuList
}: Readonly<SidePanelProps>) => {
  const t = useTranslations();
  const router = useRouter();
  /*  TODO - Input Validations - usePathName: Validate pathname is a valid
  string with alphanumeric values allowin only two special characters . Slash (/)
  and Dash (-) . UNDER INVESTIGATION - All valid part number characters*/
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [menuItem, setMenuItem] = useState('');
  const [loading, startTransition] = useTransition();

  const isLG = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  const onSideMenuChange = useCallback(
    (name: string, value: string) => {
      setMenuItem(value);
      startTransition(() => {
        const params = new URLSearchParams(searchParams.toString());
        if (value === sideMenuList.myEquipment.name) {
          params.delete(name);
        } else {
          params.set(name, value);
        }
        router.push(`${pathname}?${params.toString()}`, { scroll: false });
      });
    },
    [pathname, router, searchParams, sideMenuList.myEquipment.name]
  );

  return (
    <>
      <div
        className={`${styles['customer-account-wrapper--tabs-wrapper']} d-none d-blg-block`}
      >
        <CatSideMenu
          className={styles['customer-account__side-menu--no-border']}
        >
          {Object.values(sideMenuList).map((menu) => {
            if (!menu?.isHide) {
              return (
                <CatSideMenuItem
                  className={styles['customer-account__side-menu--list']}
                  key={menu.name}
                  isCurrent={searchParam === menu.name}
                  onClick={() => onSideMenuChange('menu', menu.name)}
                  data-track-event={menu.ga_event_name}
                  data-track-attr-nltext={menu.ga_nltext}
                  data-track-attr-context={menu.ga_context}
                >
                  <Conditional
                    test={!!menu.icon}
                    fallback={<div className="mx-4">{t(menu.label)}</div>}
                  >
                    <div className=" d-flex align-items-center">
                      <div className="mx-2">{menu.icon}</div>
                      {t(menu.label)}
                    </div>
                  </Conditional>
                </CatSideMenuItem>
              );
            }
          })}
        </CatSideMenu>
      </div>

      <div
        className={`position-relative ${styles['customer-account--content-wrapper']}  d-none d-blg-block`}
      >
        <Conditional
          test={!loading && isLG === true}
          fallback={<CustomerAccountLoading menu={menuItem || searchParam} />}
        >
          {children}
        </Conditional>
      </div>

      <div className="d-blg-none">
        <Conditional
          test={isLG === false}
          fallback={<CustomerAccountLoading menu={''} />}
        >
          {mobile}
        </Conditional>
      </div>
    </>
  );
};
